import { useTheme } from "@mui/styles";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import React from "react";

const ClosedFlapTitle = ({ children, styles = {} }) => {
  const theme = useTheme();
  return (
    <div className="row w-100">
      <div className="col-2"></div>
      <div
        className="col-7 text-start"
        style={{
          fontSize: "1rem",
          fontFamily: "hypatia-sans-pro",
          letterSpacing: "2px",
          color: theme.COLORS.BLUE.darkBlueGreen,
          ...styles,
        }}
      >
        {children}
      </div>
      <div className="col-2 flex justify-content-center align-items-center">
        <ArrowForwardIcon
          style={{
            color: theme.COLORS.BLUE.darkBlueGreen,
            ...styles,
          }}
        ></ArrowForwardIcon>
      </div>
    </div>
  );
};

export default ClosedFlapTitle;
